import { createContext, useContext } from 'react';

/**
 * Core context object for Location data.
 * Isolated in a .js file to avoid Vite Fast Refresh "only exports components" warnings.
 */
export const LocationContext = createContext(null);

/**
 * Hook to access the current location state.
 */
export function useLocation() {
  const context = useContext(LocationContext);
  if (!context) {
    throw new Error('useLocation must be used within a LocationProvider');
  }
  return context;
}

/**
 * Filter and sort locations to find active ones.
 */
export const getActiveLocations = (list) => {
  if (!list || !Array.isArray(list)) return [];
  return list
    .filter((loc) => loc.isActive !== false)
    .sort((a, b) => (a.name || '').localeCompare(b.name || ''));
};

/**
 * Discover the initial Location ID from the URL search params (POS specific).
 */
export function getInitialPosLocationId(allowedList) {
  if (typeof window === 'undefined') return null;
  const searchParams = new URLSearchParams(window.location.search);
  const locationIdFromUrl = searchParams.get('locationId') || searchParams.get('branch');

  if (locationIdFromUrl && allowedList && allowedList.some((l) => l.id === locationIdFromUrl)) {
    return locationIdFromUrl;
  }
  return null;
}
